import { IPagination } from '@app/interfaces/pagination';

export const initialPagination: IPagination = {
  current: 1,
  pageSize: 10,
  pagesCount: undefined,
  total: undefined,
};

// User remarks pagination constants
export const USER_REMARKS_INITIAL_PAGE_SIZE = 5;
export const USER_REMARKS_LOAD_MORE_PAGE_SIZE = 5;

// Work assignments pagination constants
export const WORK_ASSIGNMENTS_INITIAL_PAGE_SIZE = 5;
export const WORK_ASSIGNMENTS_LOAD_MORE_PAGE_SIZE = 5;
